<template>
	<div id="app">
		<EcpModal />
		<component :is="layout">
			<router-view></router-view>
		</component>
	</div>
</template>

<script>
import EcpModal from '@/components/EcpModal';
const default_layout = 'default';
export default {
	components: {
		EcpModal,
	},
	computed: {
		loggedIn() {
			return this.$store.getters.loggedIn;
		},
		layout() {
			return (this.$route.meta.layout || default_layout) + '-layout';
		},
	},
};
</script>

<style>
@import 'https://cdn.jsdelivr.net/npm/animate.css@3.5.1';
/* :root {
    --color-primary: #7380ec;
    --color-primary-2: #36429e;
    --color-danger: #ff7782;
    --color-success: #41f1b6;
    --color-warning: #ffbb55;
    --color-white: #fff;
    --color-info-dark: #7d8da1;
    --color-info-light: #dce1eb;
    --color-dark: #363949;
    --color-light: rgba(132, 139, 200, 0.18);
    --color-primary-variant: #111e88;
    --color-dark-variant: #677483;
    --color-background: #f6f6f9;

    --card-border-radius: 2rem;
    --border-radius-1: .4rem;
    --border-radius-2: .8rem;
    --border-radius-3: 1.2rem;

    --card-padding: 1.8rem;
    --padding-1: 1.2rem;

    --box-shadow: 0 2rem 3rem var(--color-light);
    --transition-standard: all 300ms ease;
} */

*,
*::before,
*::after {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body::-webkit-scrollbar {
	display: none;
}

.clr-primary {
	color: var(--color-primary);
}

.clr-danger {
	color: var(--color-danger);
}

.clr-warning {
	color: var(--color-warning);
}

.clr-success {
	color: var(--color-success);
}

.container {
	padding-right: 15px;
	padding-left: 15px;
	margin-right: auto;
	margin-left: auto;
}

@media (min-width: 768px) {
	.container {
		width: 750px;
	}
}

@media (min-width: 992px) {
	.container {
		width: 970px;
	}
}

@media (min-width: 1200px) {
	.container {
		/* width: 1170px; */
		width: 1300px;
	}
}
/* should be fixed */
@media (min-width: 1900px) {
	.container {
		width: 1300px;
	}
}

@media (min-width: 2000px) {
	.container {
		width: 1500px;
	}
}

.container-fluid {
	margin-left: 8rem;
}

[class*='col-'] {
	float: left;
	padding: 15px;
	/* border: 1px solid red; */
}

.col-1 {
	width: 8.33%;
}

.col-2 {
	width: 16.66%;
}

.col-3 {
	width: 25%;
}

.col-4 {
	width: 33.33%;
}

.col-5 {
	width: 41.66%;
}

.col-6 {
	width: 50%;
}

.col-7 {
	width: 58.33%;
}

.col-8 {
	width: 66.66%;
}

.col-9 {
	width: 75%;
}

.col-10 {
	width: 83.33%;
}

.col-11 {
	width: 91.66%;
}

.col-12 {
	width: 100%;
}

#app {
	/* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	min-height: 100vh;
	/* background-color: var(--color-background); */
}

.flex-center {
	display: flex;
	justify-content: center;
}
.nav {
	display: flex;
	list-style: none;
	padding: 15px 0;
	margin: 0;
	justify-content: flex-end;
	background: #f5f8fa;
	border-bottom: 1px solid lightgrey;
}

.nav a {
	color: #636b6f;
	padding: 0 25px;
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 0.1rem;
	text-decoration: none;
	text-transform: uppercase;
}

.progress-bar {
	display: flex;
	justify-content: center;
	align-items: center;
	height: inherit;
}

progress {
	border-radius: 7px;
	width: 90%;
	height: 22px;
	color: black;
}
progress::-webkit-progress-bar {
	background-color: #ededed;
	border-radius: 7px;
}
progress::-webkit-progress-value {
	background-color: #00d1b2;
	border-radius: 7px;
}

.modal-inner {
	height: 100%;
	padding: 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
	text-align: center;
}

/* .modal-inner button {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	cursor: pointer;
	font-size: 1.1rem;
	background: #7ad38d;
	color: white;
} */

table {
	user-select: text;
}

/* Loading spinner */
.spinner {
	width: 180px;
	height: 100px;
	border-radius: 1em;
	margin: 0 auto;
	text-align: center;
	margin-bottom: 5em;
}

.dot {
	width: 20px;
	height: 20px;
	background-color: #36429e;
	display: inline-block;
	margin-top: 40px;
	border-radius: 50%;
}

@keyframes boing {
	0%,
	100% {
		transform: translateY(0px);
		animation-timing-function: ease-out;
	}
	50% {
		transform: translateY(-30px);
		animation-timing-function: ease-in;
		opacity: 0.5;
	}
}

#dot1 {
	animation: boing 1s infinite;
}

#dot2 {
	animation: boing 1s ease-out;
	animation-iteration-count: infinite;
	animation-delay: 0.2s;
}

#dot3 {
	animation: boing 1s ease-out;
	animation-iteration-count: infinite;
	animation-delay: 0.4s;
}

#dot4 {
	animation: boing 1s ease-out;
	animation-iteration-count: infinite;
	animation-delay: 0.6s;
}

#dot5 {
	animation: boing 1s ease-out;
	animation-iteration-count: infinite;
	animation-delay: 0.8s;
}
</style>
